import {
	OPEN_CONSENT_MODAL,
	CLOSE_CONSENT_MODAL,
	FETCHING_CONSENT_DETAIL,
	FETCHED_CONSENT_DETAIL
} from '../../actions/ConsentModalActions';

import produce from 'immer';

export default class RegistrationFormReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static reduce(state = {}, action) {
		switch (action.type) {
			case OPEN_CONSENT_MODAL:
				return produce(state, draftState => {
					draftState.consentModal.show = true;
					draftState.consentModal.title = action.title;
					draftState.consentModal.detailUrl = action.detailUrl;
				});
			case CLOSE_CONSENT_MODAL:
				return produce(state, draftState => {
					draftState.consentModal.show = false;
				});
			case FETCHING_CONSENT_DETAIL:
				return produce(state, draftState => {
					draftState.fetchingConsentDetail = true;
				});
			case FETCHED_CONSENT_DETAIL:
				return produce(state, draftState => {
					draftState.consentDetails[action.detailUrl] = action.html;
					draftState.fetchingConsentDetail = false;
				});
			default:
				return state;
		}
	}
}



// WEBPACK FOOTER //
// ./reducers/registrationForm/ConsentModalReducer.js